/**
 * @overview 远程认证修改成绩
 * @author 3173
 * @date 2020-8-16
 */
import React from 'react';
import ReactDOM from 'react-dom'
import { connect } from 'dva';
import { component_tool, framework_tool, utils_tool } from '@/tool'
import 'antd/dist/antd.css';
import DataSet from "@antv/data-set";
import { WizModalUserIdentityShow } from '@/containers/common';
import { instanceOf, element } from 'prop-types';
import cloneDeep from 'lodash/cloneDeep'
let { WizContainer, WizReduxTemplatem, modelUtils } = framework_tool;
let { WizCard, WizIcon, WizTable, WizButton, WizModal, WizTabs, WizDataTable, WizSpin, WizInputNumber, WizTimePicker } = component_tool;
let { checkStrLength, getPageData, Session } = utils_tool;


class StudentRemoteAuthScore extends WizContainer {

  componentName = 'studentRemoteAuthScore';

  constructor(props) {
    super(props);
    let { history } = this.props;
    let initialValue = {};
    if (history && history.location && history.location.pathname === '/remoteAuth/studentRemoteAuthDetailList/studentRemoteAuthScore') {
      if (history.location && history.location.record) {
        initialValue = history.location.record;
        Session.set('studentRemoteAuthScore', initialValue)
      } else {
        initialValue = Session.get('studentRemoteAuthScore') || {};
      }
    }

    this.state = {
      infoList: [],//考卷模块
      tabIndex: 0,//当前tab标识
      totalScore: (initialValue.score && initialValue.score!=-1) ? initialValue.score : 0//总分
    }
    this.initialValue = initialValue;

  }

  _componentWillMount() {
    const { history } = this.props;
  }

  _componentDidMount() {
    this.getStudentAuthExamPager()
  }



  /**获取考卷 */
  getStudentAuthExamPager() {
    if (this.initialValue.id) {
      this.doAction({
        path: 'studentRemoteAuthDetail/getStudentRemoteAuthExamInfo',
        payload: {
          key: 'getStudentRemoteAuthExamInfo',
          apiParams: {
            id: this.initialValue.id,
            personId: this.initialValue.personId
          }
        },
        autoInit: true,
      })
    }
  }

  /**保存单个模块数据 */
  saveModuleRelation(index) {
    let { infoList, tabIndex } = this.state;
    if (infoList.length > tabIndex) {
      let studentModuleRelation = infoList[tabIndex];
      this.doAction({
        path: 'studentModuleRelation/save',
        payload: {
          key: 'saveModuleRelation',
          apiParams: {
              ...studentModuleRelation
          }
        },
        autoInit: true,
      })
    }
  }



  propsAndStateOnChange = {
    studentRemoteAuthExamInfo: this.getStudentRemoteAuthExamInfoOver.bind(this),
    saveModuleRelation: this.saveModuleRelationOver.bind(this)
  };


  /**
   * 获取考卷返回结果
   * @param nextProps
   * @param nextState
   */
  getStudentRemoteAuthExamInfoOver(nextProps, nextState) {
    if (nextProps.studentRemoteAuthExamInfo.code == 1) {
      let infoList = nextProps.studentRemoteAuthExamInfo.data.infoList;
      let examInfoList = infoList && infoList instanceof Array ?cloneDeep(infoList):[]; 
      examInfoList.forEach(element=>{
          if(element.answers && element.answers instanceof Array ){
            element.answers.forEach(answer=>{
              if(answer.score && answer.score<0){
                answer.score = undefined;
              }
            })
          }
      })
      nextState.infoList = examInfoList;
    } else {
      wizNotice.error('考卷加载失败：' + nextProps.studentRemoteAuthExamInfo.msg);
    }
    return true;
  }

  saveModuleRelationOver(nextProps, nextState) {
    if (nextProps.saveModuleRelation.code == 1) {
      wizNotice.success('操作成功')
      nextState.totalScore = nextProps.saveModuleRelation.data ? nextProps.saveModuleRelation.data :0
    } else {
      wizNotice.error('保存失败');
    }
    return true;
  }


  _onChange = (key) => {
    if (this.state.tabIndex !== key) {
      this.setState({
        tabIndex: key,
        time: new Date().getTime()
      });
    }
  }

  /** 改变行分数 */
  scoreChange(record, score) {
    let { infoList, tabIndex, totalScore } = this.state;
    let neoInfoList = cloneDeep(infoList);
    let neoTotalScore = totalScore;
    if (neoInfoList.length > tabIndex) {
      let studentModuleRelation = Object.assign({}, neoInfoList[tabIndex]);
      let neoValue = Object.assign([], studentModuleRelation.answers);
      neoValue.forEach((value, index) => {
        if (value.id === record.id) {
          var regex = /^\d*(\.[1-9]|\.\d[1-9])*$/
          if( score==''|| !score){
            neoTotalScore = neoTotalScore -  (value.score?value.score:0 );
            neoTotalScore = neoTotalScore ? neoTotalScore.toFixed(1):0;
            value.score = score;
          }else if((score || score==0 )&& regex.test(score) && score!=''){
            neoTotalScore = neoTotalScore - (value.score?value.score:0 ) + score;
            neoTotalScore = neoTotalScore ? neoTotalScore.toFixed(1):0;
            value.score = score;
          }
        }

      });
      studentModuleRelation.answers = neoValue;
      neoInfoList[tabIndex] = studentModuleRelation;
      this.setState({ infoList: neoInfoList , totalScore:neoTotalScore });
    }
  }


  /** 创建表头 */
  createColumns() {
    let { infoList, tabIndex } = this.state;
    let columns = [];
    if (infoList.length > tabIndex && infoList[tabIndex]) {
      let studentModuleRelation = infoList[tabIndex];
      let answers = studentModuleRelation.answers
      columns = [{
        title: '模拟场景',
        name: 'moduleContent',
        dataIndex: "moduleContent",

        render(value, row, index) {
          const obj = {
            children: undefined,
            props: { rowSpan: 0 },
          };
          if (index == 0) {
            obj.children = <div dangerouslySetInnerHTML={{__html: studentModuleRelation.moduleContent}}></div>,
            obj.props.rowSpan = answers ? answers.length : 0;
            return obj;
          }
          return obj
        }

      },
      {
        title: '序号',
        name: 'number',
        dataIndex: "number",

        render: (value, row, index) => { return index + 1 }

      },
      {
        title: '考题',
        name: 'questionName',
        dataIndex: "questionName",
        render: (value, row, index) => {
          const obj = {
            children: <div dangerouslySetInnerHTML={{__html: value}}></div>,
            props: {},
          };
          return obj;
        }
      },
      {
        title: '考点',
        name: 'questionContent',
        dataIndex: "questionContent",
        render: (value, row, index) => {
          const obj = {
            children: <div dangerouslySetInnerHTML={{__html: value}}></div>,
            props: {},
          };
          return obj;
        }
      },
      {
        title: '考点得分',
        name: 'score',
        dataIndex: "score",

        render: (text, record) =>{ 
          let score = record.score
          if(score==-1){
            score = undefined;
          }
          return ( 
          <WizInputNumber  max={(record.maxScore && record.maxScore >= 0) || record.maxScore == 0 ? record.maxScore : 0} value={score} precision={1} onChange={(value) => { this.scoreChange(record, value) }}/>
        )
      }
      },

      ]
    }
    return columns;
  }


  /**列表 */
  detailList() {
    const { history, studentRemoteAuthDetailLoading } = this.props;
    let { infoList, tabIndex } = this.state;

    let columns = this.createColumns(tabIndex);

    let dataItems = [];
    if (infoList.length > tabIndex) {
      let studentModuleRelation = infoList[tabIndex];
      if (studentModuleRelation && studentModuleRelation.answers instanceof Array) {
        dataItems = studentModuleRelation.answers;
        // dataItems.forEach(element => {
        //   element.key = new Date().getTime()
        // });
      }
    }

    let dataTableProps = {
      loading: false,
      columns,
      dataSource: dataItems,
      rowKey: "id",
      //selectType: "checkbox",
      rowSelection: null,
      showNum: false,
      isScroll: true,
      reasonable: true,
      pagination: false
      // onChange: ({pageNum, pageSize}) => {
      //   this.detailList(null, {current: pageNum, size: pageSize});
      // },

    };
    return (
      <>
        <WizCard className="mt-15">
          <WizTable {...dataTableProps} />
          {this.sumbitBtn()}
        </WizCard>
      </>
    )
  }

  sumbitBtn(){
    let { infoList, tabIndex } = this.state;
    if(infoList && infoList.length>0){
      return (
        <div className="sumbit-btns">
        <WizButton style={{marginLeft:'45%',marginTop:'10px'}} type="primary" className="button"  onClick={() => this.saveModuleRelation()}>保存</WizButton>
        </div>
      )
    }
  }


  /** 根据数据加载tab内容 */
  setTabs() {
    let { infoList, tabIndex } = this.state;
    let tabs = [];
    if (infoList.length > 0) {
      for (let i = 0; i < infoList.length; i++) {
        let studentModuleRelation = infoList[i];
        tabs.push(<WizTabs.TabPane tab={studentModuleRelation.moduleName} key={i}>{this.detailList(i)}</WizTabs.TabPane>)
      }
    }else{
      tabs.push(<WizTabs.TabPane tab={'暂无数据'} key={'notData'}>{this.detailList()}</WizTabs.TabPane>)
    }
    return tabs;
  }

  tabBarExtraContent(){
    return(<span style={{marginRight:40}}>
      <span className=" ant-tabs-tab" style={{color: "rgba(0, 0, 0, 0.85)",fontWeight:600,}}>总分:</span>
      <span className=" ant-tabs-tab" > {this.state.totalScore}</span>
      </span>
    )
  }

  _render() {
    const { history, studentRemoteAuthDetailLoading ,studentModuleRelationLoading} = this.props;
    let { totalScore, infoList } = this.state;

    return (
      <WizSpin tip={'加载中'} spinning={studentRemoteAuthDetailLoading || studentModuleRelationLoading}>
        <WizCard>
          <WizTabs animated={false} defaultActiveKey={infoList.length > 0 ? 0 : null} onChange={this._onChange.bind(this)}
            tabBarExtraContent={this.tabBarExtraContent()} >
            {this.setTabs()}
          </WizTabs>
        </WizCard>
      </WizSpin>
    )
  }
}


const mapStateToProps = (state, ownProps) => {
  const { studentRemoteAuthDetail, studentModuleRelation } = state;
  const studentRemoteAuthExamInfo = modelUtils.getModelEntity(studentRemoteAuthDetail, "getStudentRemoteAuthExamInfo");
  const saveModuleRelation = modelUtils.getModelEntity(studentModuleRelation, "saveModuleRelation");
  const load = modelUtils.getLoadingState(state, ['studentRemoteAuthDetail', 'studentModuleRelation']);
  return {
    studentRemoteAuthExamInfo: studentRemoteAuthExamInfo,
    saveModuleRelation: saveModuleRelation,
    ...load
  }
};

export default connect(mapStateToProps)(StudentRemoteAuthScore);

